
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import { getCurrentInstance } from "vue";
import UserData from "@/components/widgets/uob/StudentData.vue";
import AbsenceDetails from "./AbsenceDetails.vue";
import {
  setCurrentPageBreadcrumbs,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import { CourseAttendanceRequest } from "@/core/endpoints/requests/courseAttendance_request";
import { CourseAttendanceResponse } from "@/core/endpoints/responses/courseAttendance_response";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";

export default defineComponent({
  name: "courseAttendance",
  components: {
    UserData,
    AbsenceDetails,
  },
  setup() {
    const { t, te } = useI18n();
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };
    onMounted(() => {
      setCurrentPageTitle(translate("courseAttendance.title"));
      setCurrentPageBreadcrumbs(
        translate("courseAttendance.title"),
        translate("courseAttendance.title"),
        []
      );
    });

    const app = getCurrentInstance();
    const courseAttendanceRequest = new CourseAttendanceRequest();
    const courseAttendanceRes = ref();
    const courseAbsenceDetailsRes = ref();
    const edStudId = ref();

    const setStudenInfo = (student) => {
      courseAttendanceRequest.EdStudId = student.edStudId;
      edStudId.value = student.edStudId;
      getStudentAttendance();
    };

    // Get Data in Table
    const getStudentAttendance = () => {
      courseAttendanceRequest.invokeGetStudentAttendance(
        app,
        (me: any, courseAttendanceResponse: CourseAttendanceResponse) => {
          if (courseAttendanceResponse) {
            let res: any = {};
            res = courseAttendanceResponse;
            courseAttendanceRes.value = res.studentAttendanceLst;
          }
        }
      );
    };

    const openDrawer = (edCourseId) => {
      courseAttendanceRequest.EdCourseId = edCourseId;
      courseAttendanceRequest.invokeGetStudentCourseAbsenceDetails(
        app,
        (me: any, courseAttendanceResponse: CourseAttendanceResponse) => {
          if (courseAttendanceResponse) {
            courseAbsenceDetailsRes.value = courseAttendanceResponse;
            DrawerComponent?.getInstance("kt_drawer_chat")?.toggle();
          }
        }
      );
    };

    return {
      translate,
      setStudenInfo,
      courseAttendanceRes,
      courseAbsenceDetailsRes,
      openDrawer,
    };
  },
});
